<template>
	<m-main-layout>
		<el-button @click="$router.back()">返回</el-button>
		<el-table border size="mini" :data="list" style="width: 100%;margin-top:10px;">
			<el-table-column type="index" label="排序"></el-table-column>
			<el-table-column prop="company" label="标讯">
				<template slot-scope="scope">
					<a :href="$config.webUrl + '/bids/detail/'+scope.row.tid" target="_blank">{{scope.row.title}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="count" label="报名数" width="80px">
				<template slot-scope="scope">
					<b class="hand" @click="$router.push({path:'/bids/baoming',query:{id:scope.row.tid}})">{{scope.row.count}}</b>
				</template>
			</el-table-column>
		</el-table>
		<div class="padding-top-bottom-20 text-center">
			<el-pagination
				background
				layout="total,prev, pager, next"
				:page-size="searchForm.pageSize"
				:current-page.sync="searchForm.page"
				:total="totalCount"
				@current-change="pageChange">
			</el-pagination>
		</div>
	</m-main-layout>
</template>

<script>
export default {
	name: "toubiao",
	data() {
		return {
			searchForm:{
				page:1,
				pageSize:20,
				orderBy:'click_count',
				sortBy:'desc'
			},
			totalCount:0,
			list:[]
		}
	},
	created() {
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList(){
			let _this = this;

			_this.$http.httpPost({
				url: '/UserToubiaoLog/getTotal',
				datas: this.searchForm,
				success: (res) => {
					_this.list = res.list;
					_this.totalCount = res.totalCount;
				}
			});
		},
		pageChange(page){
			this.page = page;
			this.getList();
		},
	}
}
</script>
